import { render, staticRenderFns } from "./StudyList.vue?vue&type=template&id=71d1337d&scoped=true&"
import script from "./StudyList.vue?vue&type=script&lang=js&"
export * from "./StudyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d1337d",
  null
  
)

export default component.exports